import { ModelBase, NeoModel } from '@singularsystems/neo-core';


@NeoModel
export default class IncentiveGroup extends ModelBase {
    incentiveGroupId: number = 0;

    incentiveGroupName: string = ""
}